import { useState, useEffect, useCallback, useRef } from 'react';
import { useDraggable } from "react-use-draggable-scroll";
import { Link } from 'react-router-dom';
import XLSX from "xlsx";
import { v4 as uuidv4 } from 'uuid';
import { Button, Grid, Table, TextField, TableBody, TableContainer, Paper, TablePagination, Typography, TableCell, TableHead, TableRow } from '@mui/material';
import FclCostHeader from './FclCostHeader';
import FclCostRow from './FclCostRow';
import AddFclCost from './AddFclCost';
import RowRate from './RowRate';
import { useSelector, useDispatch } from 'react-redux';
import { snackbarToggle } from '../../../reducers/snackbarSlicer';
import { onPageChange, onSizeChange } from '../../../reducers/admin-reducers/AdminSlicer';
import { onFclCostChange } from '../../../reducers/crm/crmSlice';
import { Dialog, Snackbar } from '../../../style-guide';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import { ofList, pssList, conList, bafList, cnlList, gpsList, enList, isList, lrList, wrsList, ieiList, ebsList, scsList, obsList, eisList, esList, vispsList, lsaList, rateList } from '../../../constants/global-constants';

import { FaAngleLeft, FaPlus, FaCloudUploadAlt } from "react-icons/fa";
import { getFclExportImportAF, addAirExportAF, addFclExportImportAF } from '../../../reducers/requestHandler';

import { getCRMList, getFclExportImportAFsPagination, getLocalChargesByShipProd, deleteFclExportImportAF } from '../../../reducers/requestHandler';
import MenuItem from '@mui/material/MenuItem';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { parcelStatusList, parcelSortBy, SHIPPING_STATUS_LIST, paginationArr } from '../../../constants/global-constants';
import "../cost.css";

export const FclCostTable = props => {
    //const { crmListFilter } = useSelector(state => state.parameter);
    const { crmList } = useSelector(state => state.crm);
    const { isLoading, countryList, listOfPort, listOfAirLine, listOfMeasurementUnits, listOfcurrency, qsStatusList, listOfIncoterms, listOfServiceType } = useSelector(state => state.parameter);

    const ref = useRef();
    const {  paginationData } = useSelector(state => state.admin);
    const { events } = useDraggable(ref);
    const dispatch = useDispatch();
    const { currentPage, admin } = useSelector(state => state.session);
    const { snackbar } = useSelector(state => state.snackbar);
    const onSnackbarHandleClose = () => dispatch(snackbarToggle(false));
    const failedCallback = useCallback(
        message => dispatch(snackbarToggle({ type: 'error', message })),
        [dispatch],
    );

    const setTruckingCompany = (text) => {
        setTruckingCompany1(text);
        if (text) {
            var t = airImportExportTemp1.filter(item => item.params?.TRUCKER_NAME?.includes(text));
            setFclImportExportTemp(t);
        } else
            setFclImportExportTemp(airImportExportTemp1);
    }
    const setFclImportExport = (data) => {
        setFclImportExportTemp(data)
        setFclImportExportTemp1(data)
    }
    const [truckingCompany, setTruckingCompany1] = useState(0);
    const [loadingData, setLoadingDataLCL] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorLclEl, setAnchorLclEl] = useState(null);
    const [anchorFclEl, setAnchorFclEl] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [bSettingOpen, setSettingOpen] = useState(false);
    const [airImportExportTemp1, setFclImportExportTemp1] = useState(false);
    const [airImportExport, setFclImportExportTemp] = useState(false);
    const open = Boolean(anchorEl);
    const openLcl = Boolean(anchorLclEl);
    const openFcl = Boolean(anchorFclEl);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = () => {
        
        setOpenOrderModal(true);
    };
    const handleChange = (event) => {
    };
    const setSelectedFclCost = (id, bSelected) => {
        var t = []
        for (var i = 0; i < airImportExport.length; i++) {
            var tt = { ...airImportExport[i] }
            if (tt.id == id) {
                tt.bSelected = bSelected;
            }
            t.push(tt)
        }
        //setFclImportExport([])
        window.setTimeout(function () {
            setFclImportExport(t)
        }, 0);

    }
    const isAnySelectedForCopy = (event) => {
        var numSelected = 0;
        for (var i = 0; i < airImportExport.length; i++) {
            if (airImportExport[i].bSelected) {
                numSelected++
            }
        }
        return numSelected == 1;
    };

    const getSelectedforcopy = () => {
        for (var i = 0; i < airImportExport.length; i++) {
            if (airImportExport[i].bSelected) {
                return airImportExport[i];
            }
        }
    }

    const deSelectAllFclCost = () => {
        var t = []
        for (var i = 0; i < airImportExport.length; i++) {
            var tt = { ...airImportExport[i] }
            tt.bSelected = false;
            t.push(tt)
        }
        setFclImportExport([])
        window.setTimeout(function () {
            setFclImportExport(t)
        }, 0);

    }
    const selectAllFclCost = () => {
        var t = []
        for (var i = 0; i < airImportExport.length; i++) {
            var tt = { ...airImportExport[i] }
            tt.bSelected = true;
            t.push(tt)
        }
        setFclImportExport([])
        window.setTimeout(function () {
            setFclImportExport(t)
        }, 0);

    }
    const onHandleCancelModal = () => {
        getFclCostData();
        setOpenOrderModal(false)
    };
    const handleClick = event => {
        setSettingOpen(true);
        setAnchorEl(event.currentTarget);
    };
    const handleLclClick = event => {
        setSettingOpen(true);
        setAnchorLclEl(event.currentTarget);
    };
    const handleFclClick = event => {
        
        setSettingOpen(true);
        setAnchorFclEl(event.currentTarget);
    };
    const handleClose = () => {
        setSettingOpen(false);
        setAnchorEl(null);
        setAnchorFclEl(null);
        setAnchorFclEl(null);
    };
    const onPageHandleChange = (_, newPage) => {
        dispatch(onPageChange(newPage))
    };
    const onRowsPerPageHandleChange = event => {
        dispatch(onSizeChange(+event.target.value))
        dispatch(onPageChange(0))
    };
    const getFclImportLocalChargesItemByName = (name) => {
        return [{ name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Port fees', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Global Gate fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'AMS', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'OTHC', unitOfMeasure: 4, currency: 4, rate: 0, min: 0 },
            { name: 'INLAND FREIGHT', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'ISPS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'VGM', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'PSS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Stuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 },
            { name: 'PORT FEES', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Warehouse Handeling Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Exw Charges', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 },
            { name: 'COO', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Communication Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Congestion', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Eur1', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 },
            { name: 'Imo Handeling', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }]
        //var localChargesItems = [{ product: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Communication', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Congestion', unitOfMeasure: 3, currency: 1, rate: 1, min: 0 }, { product: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 1, min: 0 }, { product: 'DTHC', unitOfMeasure: 3, currency: 4, rate: 1, min: 0 }, { product: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 1, min: 0 }, { product: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'ISPS', unitOfMeasure: 3, currency: 1, rate: 0, min: 10 }, { product: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { product: 'Local charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { product: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { product: 'UnStuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }]
        //return localChargesItems
    }
    const getFclExportLocalChargesItemByName = (name) => {
        return [{ name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Port fees', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Global Gate fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'AMS', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'OTHC', unitOfMeasure: 4, currency: 4, rate: 0, min: 0 },
            { name: 'INLAND FREIGHT', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'ISPS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'VGM', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'PSS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Stuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 },
            { name: 'PORT FEES', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Warehouse Handeling Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Exw Charges', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 },
            { name: 'COO', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Communication Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Congestion', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Eur1', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 },
            { name: 'Imo Handeling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }]
        //var localChargesItems = [{ product: 'Imo Handeling', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Congestion', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'COO', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Communication Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Warehouse Handeling Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'PSS', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'ISPS', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'AMS', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'B/L fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'OTHC', unitOfMeasure: 2, currency: 4, rate: 1, min: 0 }, { product: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { product: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'BL fees', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Global Gate Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'C.O.O', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Communication', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Courier', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 1, min: 0 }, { product: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'EUR1', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'EBS', unitOfMeasure: 4, currency: 1, rate: 1, min: 0 }, { product: 'Export License', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 1, min: 0 }, { product: 'Insurance Handling', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { product: 'Lift on', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { product: 'Packing', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'Storage', unitOfMeasure: 1, currency: 1, rate: 1, min: 0 }, { product: 'Stuffing', unitOfMeasure: 5, currency: 1, rate: 1, min: 0 }, { product: 'Warehouse handling fee', unitOfMeasure: 3, currency: 1, rate: 1, min: 0 }, { product: 'VGM', unitOfMeasure: 4, currency: 1, rate: 1, min: 0 }, { product: 'Customs Inspection', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }, { product: 'AWB Fee', unitOfMeasure: 2, currency: 1, rate: 1, min: 0 }]
        //return localChargesItems
    }
    const [costChanrges, setCostCharges] = useState([]);

    const [fclCostData, setFclCostData] = useState({
        crmId: "",
        countryId: "",
        ShippingCrmId: "",       
        portAid: "",
        portLid: "",
        zip: "",
        rate20: "",
        rate40: "",
        
    });
    const getFclCostData = () => {
        setFclImportExport([])
        var data1 = {
            numItems: paginationData.size,
            pageNum: paginationData.page+1,
            importExportType: props.data?.id,
            crmId: fclCostData.crmId,
            countryId: fclCostData.countryId,
            ShippingCrmId: fclCostData.ShippingCrmId,
            portAid: fclCostData.portAid,
            portLid: fclCostData.portLid,
            zip: fclCostData.zip,
            rate20: fclCostData.rate20,
            rate40: fclCostData.rate40,
        }
        //setLoadingDataLCL(true);
        if (props.data?.id && props.data?.id != 4 && props.data?.id != 5) {
            getFclExportImportAFsPagination(dispatch, admin, data1, function (da) {
                var data = [];
                for (var i = 0; i < da.length; i++) {
                    var d1 = da[i];
                    d1.AGENT = crmList.find(u => u.id === d1.agentCrmId)?.companyName || '-';
                    d1.SHIPLINE = crmList.find(u => u.id === d1.shippingCrmId)?.companyName || '-';
                    d1.COUNTRY = countryList.find(u => u.id === d1.countryId)?.name || '-';
                    d1.PORTL = listOfPort.find(u => u.id === d1.portLid)?.name || '-';
                    d1.PORTA = listOfPort.find(u => u.id === d1.portAid)?.name || '-';
                    data.push(d1);
                }
                setFclImportExport(data)
                console.log("loader false")
                setLoadingDataLCL(false);
            });
            if (props.data?.id == 1) {
                setCostCharges(getFclExportLocalChargesItemByName())
            }
            if (props.data?.id == 2) {
                setCostCharges(getFclImportLocalChargesItemByName())
            }
        } else if (props.data?.id && props.data?.id == 4 || props.data?.id == 5) {
            data1 = {
                "importExportType": props.data?.id,
                "shipmentTypeId":3
            }
            //getLocalChargesByShipProd(dispatch, admin, data1, setFclImportExport);
            getLocalChargesByShipProd(dispatch, admin, data1, function (da) {
                var tData = [...da]

                if (props.data?.id == 5 && tData.length) {
                    var t = [{ name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Handling fee', unitOfMeasure: 2, currency: 0, rate: 0, min: 0 }, { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Global Gate fee', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'AMS', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 }, { name: 'OTHC', unitOfMeasure: 3, currency: 4, rate: 0, min: 0 }, { name: 'INLAND FREIGHT', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ISPS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'VGM', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'PSS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Stuffing', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'PORT FEES', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Warehouse Handeling Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Collection Fee', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Exw Charges', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'COO', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Communication Fee', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Congestion', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Delivery Order', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Eur1', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Imo Handeling', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }]
                    for (var i = 0; i < t.length; i++) {
                        var item = da.find(u => u.product === t[i].name)
                        if (!item) {
                            var tItem = { ...da[0], id: null, product: t[i].name, rate: t[i].rate, min: t[i].min, currency: t[i].currency, unitOfMeasure: t[i].unitOfMeasure }
                            tData.push(tItem)
                        } else {
                            tData[i] = item;
                        }
                    }
                }
                if (props.data?.id == 4 && tData.length) {
                    var t = [{ name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Handling fee', unitOfMeasure: 2, currency: 0, rate: 0, min: 0 }, { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Global Gate fee', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'AMS', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 }, { name: 'OTHC', unitOfMeasure: 3, currency: 4, rate: 0, min: 0 }, { name: 'INLAND FREIGHT', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ISPS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'VGM', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'PSS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Stuffing', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'PORT FEES', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Warehouse Handeling Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Collection Fee', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Exw Charges', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'COO', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Communication Fee', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Congestion', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Delivery Order', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Eur1', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Imo Handeling', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }]
                    if (tData.length != t.length) {
                        tData = []
                    }
                    for (var i = 0; i < t.length; i++) {
                        var item = da.find(u => u.product === t[i].name)
                        if (!item) {
                            var tItem = { ...da[0], id: null, product: t[i].name, rate: t[i].rate, min: t[i].min, currency: t[i].currency, unitOfMeasure: t[i].unitOfMeasure }
                            tData.push(tItem)
                        } else {
                            tData[i] = item;
                        }
                    }
                }
                var data = [];
                for (var i = 0; i < tData.length; i++) {
                    var d1 = tData[i];
                    d1.COUNTRY = countryList.find(u => u.id === d1.countryId)?.name || '-';
                    d1.PORTL = listOfPort.find(u => u.id === d1.portLid)?.name || '-';
                    data.push(d1);
                }
                setFclImportExport(data)
                console.log("loader false")
                setLoadingDataLCL(false);
            });
        }
    }
    const deleteFclCost = (id) => {
        var data1 = {
            id: id,
            
        }
        deleteFclExportImportAF(dispatch, admin, data1, function () {
            getFclCostData();
        });
    }
    /*if (!isLoaded && admin.data.session) {
        getFclCostData();
        setIsLoaded(true);
    }*/
    useEffect(() => {
        if (admin.data.session) {
            //setLoadingData(true);
            getFclCostData();
        }
        //getAirCostData();
    }, [paginationData.page, paginationData.size, fclCostData]);
    useEffect(() => {
        if (!crmList.length) {
            getCRMList(dispatch, admin);
        }
        //getAirCostData();
    }, [crmList]);
    /*useEffect(() => {
        getFclCostData();
    }, [paginationData.page, paginationData.size, dispatch, failedCallback, fclCostData]);*/


    const [selectedData, setSelectedData] = useState({});
    const [ofList1, setofList] = useState([...ofList]);
    const [pssList1, setpssList] = useState([...pssList]);
    const [conList1, setconList] = useState([...conList]);
    const [bafList1, setbafList] = useState([...bafList]);
    const [cnlList1, setcnlList] = useState([...cnlList]);
    const [gpsList1, setgpsList] = useState([...gpsList]);
    const [enList1, setenList] = useState([...enList]);
    const [isList1, setisList] = useState([...isList]);
    const [lrList1, setlrList] = useState([...lrList]);
    const [wrsList1, setwrsList] = useState([...wrsList]);
    const [ieiList1, setieiList] = useState([...ieiList]);
    const [ebsList1, setebsList] = useState([...ebsList]);
    const [scsList1, setscsList] = useState([...scsList]);
    const [obsList1, setobsList] = useState([...obsList]);
    const [eisList1, seteisList] = useState([...eisList]);
    const [esList1, setesList] = useState([...esList]);
    const [vispsList1, setvispsList] = useState([...vispsList]);
    const [lsaList1, setlsaList] = useState([...lsaList]);
    const [rateList1, setrateList] = useState([...rateList]);
    const changeHandler = (event) => {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = e => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            console.log(rABS, wb);
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            var keys = data[0];
            var XL_row_object = []
            for (var i = 1; i < data.length; i++) {
                var t = {}
                keys.forEach(function (key, index) {
                    if (data[i][index])
                        t[key] = data[i][index];
                })
                if (data[i].length > 0) {
                    var objToSave = {
                        importExportType: props.data.id,
                    }
                    XL_row_object.push(t)
                    if (props.data.id == 2 || props.data.id == 1) {
                        if (t['Agent /Shipping Line']) {
                            var val = t['Agent /Shipping Line'];
                            var valArr = val.split("/");
                            var agentName = valArr[0];
                            var shippingName = valArr[1];
                            objToSave.agentCrmId = crmList.find(u => u.companyName.toLowerCase() === agentName.toLowerCase())?.id
                            objToSave.shippingCrmId = crmList.find(u => u.companyName.toLowerCase() === shippingName.toLowerCase())?.id
                           
                        } else {
                            alert("Please Select apropriate file.");

                            return;
                        }
                        if (t['Country']) {
                            objToSave.countryId = countryList.find(u => u.name.toLowerCase() === t['Country'].toLowerCase())?.id
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }
                        if (t['POL']) {
                            objToSave.portLid = listOfPort.find(u => u.name.toLowerCase() === t['POL'].toLowerCase())?.id
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }
                        if (t['POA']) {
                            objToSave.portAid = listOfPort.find(u => u.name.toLowerCase() === t['POA'].toLowerCase())?.id
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }


                        var setWeightAndValidity = function (key, key1, data) {
                            if (t[key]) {
                                data.weight = Number(t[key]);

                            } else {
                                return false;
                            }
                            if (t[key1]) {
                                var date = new Date(Math.round((t[key1] - (25567 + 1)) * 86400 * 1000));
                                data.validDate = date.getTime()
                            } else {
                                return false;
                            }
                            return true;
                        }
                        if (!setWeightAndValidity('O/F rate 20', 'O/F VALIDITY 20', ofList1[0])) {
                            alert("Please Select apropriate file.");
                            return;
                        };


                        if (!setWeightAndValidity('O/F rate 40', 'O/F VALIDITY 40', ofList1[1])) { alert("Please Select apropriate file."); return; };


                        if (!setWeightAndValidity('PSS 20', 'PSS VALIDITY 20', pssList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('PSS 40', 'PSS VALIDITY 40', pssList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('CON 20', 'CON VALIDITY 20', conList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('CON 40', 'CON VALIDITY 40', conList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('BAF 20', 'BAF VALIDITY 20', bafList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('BAF 40', 'BAF VALIDITY 40', bafList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('GFS 20', 'GFS VALIDITY 20', gpsList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('GFS 40', 'GFS VALIDITY 40', gpsList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('CNL 20', 'CNL VALIDITY 20', cnlList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('CNL 40', 'CNL VALIDITY 40', cnlList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('EN 20', 'EN VALIDITY 20', enList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('EN 40', 'EN VALIDITY 40', enList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('IS 20', 'IS VALIDITY 20', isList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('IS 40', 'IS VALIDITY 40', isList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('LR 20', 'LR VALIDITY 20', lrList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('LR 40', 'LR VALIDITY 40', lrList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('WRS 20', 'WRS VALIDITY 20', wrsList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('WRS 40', 'WRS VALIDITY 40', wrsList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('IEI 20', 'IEI VALIDITY 20', ieiList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('IEI 40', 'IEI VALIDITY 40', ieiList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('EBS 20', 'EBS VALIDITY 20', ebsList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('EBS 40', 'EBS VALIDITY 40', ebsList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('SCS 20', 'SCS VALIDITY 20', scsList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('SCS 40', 'SCS VALIDITY 40', scsList1[1])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('OBS 20', 'OBS VALIDITY 20', obsList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('OBS 40', 'OBS VALIDITY 40', obsList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('EIS 20', 'EIS VALIDITY 20', eisList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('EIS 40', 'EIS VALIDITY 40', eisList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('ES 20', 'ES VALIDITY 20', esList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('ES 40', 'ES VALIDITY 40', esList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('VISPS 20', 'VISPS VALIDITY 20', vispsList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('VISPS 40', 'VISPS VALIDITY 40', vispsList1[1])) { alert("Please Select apropriate file."); return; };

                        if (!setWeightAndValidity('LSA 20', 'LSA VALIDITY 20', lsaList1[0])) { alert("Please Select apropriate file."); return; };
                        if (!setWeightAndValidity('LSA 40', 'LSA VALIDITY 40', lsaList1[1])) { alert("Please Select apropriate file."); return; };
                        var params = {};
                        params.TRUCKER_NAME = "";
                        objToSave.params = params;
                        if (t['TRUCKER NAME']) {
                            objToSave.params.TRUCKER_NAME = t['TRUCKER NAME'];
                        }
                        objToSave.params.OF_CAHRGES = [{ currency: 1, min: 0.0, name: "Ocean Freight", rate40: "", rate20: "", remark: "", unitOfMeasure: 4, weight: 0, validDate: "" }];
                        if (t['O/F rate 20']) {
                            objToSave.params.OF_CAHRGES[0].rate20 = t['O/F rate 20'];
                        }
                        if (t['O/F rate 40']) {
                            objToSave.params.OF_CAHRGES[0].rate40 = t['O/F rate 40'];
                        }




                    } else {

                        if (t['ORG']) {
                            objToSave.countryId = countryList.find(u => u.name.toLowerCase() === t['ORG'].toLowerCase())?.id
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }
                        if (t['POL']) {
                            objToSave.portLid = listOfPort.find(u => u.name.toLowerCase() === t['POL'].toLowerCase())?.id
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }

                        if (t['ZIP']) {
                            objToSave.zip = t['ZIP']
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }
                        var rList = [...rateList1]
                        rList[0].weight = 0;
                        rList[1].weight = 0;
                        var params = {};
                        params.TRUCKER_NAME = "";
                        objToSave.params = params;
                        if (t['TRUCKER NAME']) {
                            objToSave.params.TRUCKER_NAME = t['TRUCKER NAME'];
                        }
                        objToSave.params.OF_CAHRGES = [{ currency: 1, min: 0.0, name: "Ocean Freight", rate40: "", rate20: "", remark: "", unitOfMeasure: 4, weight: 0, validDate :""}];
                        if (t['O/F rate 20']) {
                            objToSave.params.OF_CAHRGES[0].rate20 = t['O/F rate 20'];
                        }
                        if (t['O/F rate 40']) {
                            objToSave.params.OF_CAHRGES[0].rate40 = t['O/F rate 40'];
                        }
                        if (t['20DV']) {
                            rList[0].weight = Number(t['20DV']);
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }
                        if (t['40HC']) {
                            rList[1].weight = Number(t['40HC']);
                        } else {
                            alert("Please Select apropriate file.");
                            return;
                        }
                    }
                    objToSave.ofList = ofList1;
                    objToSave.pssList = pssList1;
                    objToSave.conList = conList1;
                    objToSave.bafList = bafList1;
                    objToSave.gpsList = gpsList1;
                    objToSave.cnlList = cnlList1;
                    objToSave.enList = enList1;
                    objToSave.isList = isList1;
                    objToSave.lrList = lrList1;
                    objToSave.wrsList = wrsList1;
                    objToSave.ieiList = ieiList1;
                    objToSave.ebsList = ebsList1;
                    objToSave.scsList = scsList1;
                    objToSave.obsList = obsList1;
                    objToSave.eisList = eisList1;
                    objToSave.esList = esList1;
                    objToSave.vispsList = vispsList1;
                    objToSave.lsaList = lsaList1;
                    objToSave.rateList = rateList1;
                    //$scope.addLclExportImportAF1();
                    addFclExportImportAF(dispatch, snackbarToggle, objToSave, admin, function () { })
                }

            }
            console.log(XL_row_object)
            window.setTimeout(function () {
                getFclCostData()
            }, 1500)

            /* Update state */
            //var cols= make_cols(ws["!ref"])
            //this.setState({ data: data, cols: make_cols(ws["!ref"]) });
        };
        var file = event.target.files[0];
        if (file) {
            if (rABS) reader.readAsBinaryString(file);
            else reader.readAsArrayBuffer(file);
        }
    };
    const jsonToExcel = function (data, name, header) {
        //{ skipHeader: true }
        var ws = XLSX.utils.json_to_sheet(data, header);

        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");

        /* write workbook and force a download */
        XLSX.writeFile(wb, name + ".xlsx");
    }
    const exportCsv = () => {
        var data_main = [];
        var header = ["TruckingCompany", "Country", "Port", "ZIP", "Rate20", "Rate40"]
        //data_main.push(header);
        for (var i = 0; i < airImportExportTemp1.length; i++) {
            var data = {
                "TruckingCompany": airImportExportTemp1[i].params?.TRUCKER_NAME,
                "Country": airImportExportTemp1[i].COUNTRY,
                "Port": airImportExportTemp1[i].PORTL,
                "ZIP": airImportExportTemp1[i].zip,
                "Rate20": airImportExportTemp1[i].rateList[0].weight,
                "Rate40": airImportExportTemp1[i].rateList[1].weight,
            };
            data_main.push(data);
        }
        jsonToExcel(data_main, "FCL Land Transport", header);
    }
    const handleSubmission = () => {
        var fileInput = document.getElementById('file');
        var element = document.getElementById("file_container");
        if (fileInput) {
            element.removeChild(fileInput);
        }
        var x = document.createElement("INPUT");
        x.setAttribute("type", "file");
        x.setAttribute("id", 'file');
        x.style.display = "none";
        element.appendChild(x);

        document.getElementById("file").addEventListener("change", changeHandler, true);
        document.getElementById('file').click();

    };
    const [over, setOnOver] = useState(0);

    const [openOrderModalDelete, setOpenOrderModalDelete] = useState(false);
    const onHandleOpenModalDelete = () => {
        setOpenOrderModalDelete(true);
    };
    const onHandleCancelModalDelete = () => setOpenOrderModalDelete(false);
    const isAnySelected = (event) => {
        for (var i = 0; i < airImportExport.length; i++) {
            if (airImportExport[i].bSelected) {

                return true
            }
        }
    };
    return (
        <>{<Grid container item xs={12} justifyContent='end' id="file_container">
            
            {openOrderModal && (
                <Dialog maxWidth='md' open={openOrderModal} title={props.data.lable} onHandleCancel={onHandleCancelModal}>
                    <AddFclCost callBack={getFclCostData} typeData={props.data} data={selectedData} importExportType={props.data?.id} onHandleCancel={() => onHandleCancelModal()} id={null} charges={props.data?.id != 4 && props.data?.id != 5 ? costChanrges : airImportExport} setAirImportExport={props.data?.id != 4 && props.data?.id != 5 ? setCostCharges : setFclImportExport} />
                    {/*<AddFclCost callBack={getFclCostData} typeData={props.data} data={selectedData} importExportType={props.data?.id} onHandleCancel={() => onHandleCancelModal(false)} id={null} charges={costChanrges} setCostCharges={setCostCharges} />*/}
                </Dialog>
            )}
            {(props.data?.id == 5 || props.data?.id == 4) && <Button variant='contained' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 2, background: "#F56C6C" }} onClick={function () { setSelectedData(null); onHandleOpenModal() }}>
                <FaPlus style={{ marginRight: 5 }} />  Edit
            </Button>
            }
            {props.data?.id == 3 && <Button variant='contained' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 2, background: "#F56C6C" }} onClick={exportCsv}>
                Export CSV
            </Button>}
            
            {(props.data?.id == 1 || props.data?.id == 2 || props.data?.id == 3) && <Button variant='contained' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 2, background: "#F56C6C" }} onClick={function () { setSelectedData(null); onHandleOpenModal() }}>
                <FaPlus style={{ marginRight: 5 }} />  Create
            </Button>
            }
            {(props.data?.id == 1 || props.data?.id == 2 || props.data?.id == 3) && <Button variant='contained' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 2, background: (over == 0 ? '#85ce61 !important' : '#85ce61 !important') }} onClick={handleSubmission}>
                <FaCloudUploadAlt style={{ marginRight: 5 }} />Upload Csv
            </Button>
            }
            {props.data?.id == 1 && <Button variant='outlined' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 4, justifyContent: 'flex-end' }} onClick={function () { }}>
                <Link style={{ textDecoration: 'none', color: 'inherit', fontSize: 12 }} to="../../../../../files/fcl_export_of.xlsx" target="_blank" download>Template</Link>

            </Button>
            }
            {props.data?.id == 2 && <Button variant='outlined' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 4, justifyContent: 'flex-end' }} onClick={function () { }}>
                <Link style={{ textDecoration: 'none', color: 'inherit', fontSize: 12 }} to="../../../../../files/fcl_import_of.xlsx" target="_blank" download>Template</Link>

            </Button>
            }
            {props.data?.id == 3 && <Button variant='outlined' sx={{ mt: -4, height: "4.5vh", mb: 1, mr: 4, justifyContent: 'flex-end' }} onClick={function () { }}>
                <Link style={{ textDecoration: 'none', color: 'inherit', fontSize: 12 }} to="../../../../../files/fcl_land_transport.xlsx" target="_blank" download>Template</Link>

            </Button>
            }
            <Paper sx={{ width: '100%', overflow: 'auto' }} {...events} ref={ref}>
                {
                    <TableContainer sx={{ height: "calc(100vh - 170px)" }}>
                        <Table>
                            {loadingData && <TableHead><TableRow><TableCell xs={12} style={{ width: "100%", padding: '8px' }}> <Grid item container justifyContent="center"><div className="spinner-container1">
                                <div className="loading-spinner1"></div>
                            </div></Grid></TableCell></TableRow></TableHead>}
                            {!loadingData && <FclCostHeader truckingCompany={truckingCompany} setTruckingCompany={setTruckingCompany} fclCostData={fclCostData} setFclCostData={setFclCostData} id={props.data.id} />}
                            <TableBody>
                                {airImportExport.length > 0 &&
                                    airImportExport.map(crm => (
                                        <FclCostRow setSelectedFclCost={setSelectedFclCost} deleteFclCost={deleteFclCost} typeData={props.data} importExportType={props.data?.id} key={crm?.id || uuidv4()} id={props.data.id} data={crm} openDialog={function () {
                                            getFclExportImportAF({ id: crm.id }, admin, function (data) {

                                                setSelectedData(data?.data);
                                                onHandleOpenModal()
                                            })


                                            //setSelectedData(crm); onHandleOpenModal()
                                        }} />
                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>

                }
                <Grid container item justifyContent="space-between">
                    <Grid container item justifyContent="flex-start" lg={8}>
                        <Button variant='contained' sx={{ mt: 1, height: "4.5vh", mb: 1, mr: 2, background: '#F56C6C !important' }} onClick={() => { selectAllFclCost() }}>
                            Select All
                        </Button>
                        <Button variant='contained' sx={{ mt: 1, height: "4.5vh", mb: 1, mr: 2, background: '#F56C6C !important' }} onClick={() => { deSelectAllFclCost() }}>
                            DeSelect All
                        </Button>
                        <Button disabled={!isAnySelected()} variant='contained' sx={{ mt: 1, height: "4.5vh", mb: 1, mr: 2, background: '#F56C6C !important' }} onClick={() => {

                            onHandleOpenModalDelete()
                        }}>
                            Delete Selected
                        </Button>
                        <Button disabled={!isAnySelectedForCopy()} variant='contained' sx={{ mt: 1, height: "4.5vh", mb: 1, mr: 2, background: '#F56C6C !important' }} onClick={function () {
                            var sData = JSON.parse(JSON.stringify(getSelectedforcopy()));
                            sData.id = null;
                            setSelectedData(sData);

                            onHandleOpenModal()
                        }}>
                            Copy
                        </Button>
                    </Grid>
                </Grid>
                {openOrderModalDelete && (
                    <Dialog maxWidth='md' open={openOrderModalDelete} title={props.data.lable} onHandleCancel={onHandleCancelModalDelete}>
                        <Grid container item>  Are you sure, you want to delete?</Grid>
                        <Button variant='contained' sx={{ mt: 1, height: "4.5vh", mb: 1, mr: 2, background: '#F56C6C !important' }} onClick={() => {

                            for (var i = 0; i < airImportExport.length; i++) {
                                if (airImportExport[i].bSelected) {

                                    deleteFclCost(airImportExport[i].id)
                                }
                            }
                            onHandleCancelModalDelete()
                        }}>
                            Delete Selected
                        </Button>
                    </Dialog>
                )}
                {(props.data?.id && props.data?.id != 4 && props.data?.id != 5) && <TablePagination
                    rowsPerPageOptions={paginationArr}
                    component='div'
                    count={paginationData.parcelCount}
                    rowsPerPage={paginationData.size}
                    page={paginationData.page}
                    onPageChange={onPageHandleChange}
                    onRowsPerPageChange={onRowsPerPageHandleChange}
                />}
                {snackbar && (
                    <Snackbar
                        open={!!snackbar}
                        message={snackbar.message}
                        type={snackbar.type}
                        onClose={onSnackbarHandleClose}
                    />
                )}
            </Paper>
        </Grid>}</>


    );
};
export default FclCostTable;
